module.exports = __webpack_public_path__ + "static/media/s4.7550935d.png";